const colors = {
  blue: {
    blue700: "#023150",
    blue600: "#034978",
    blue500: "#076097",
    blue400: "#1272AB",
    blue300: "#1388C9",
    blue200: "#139DDD",
    blue100: "#40C3F7",
    blue50: "#C2F0FF",
  },
  gray: {
    gray900: "#091F34",
    gray800: "#102A43",
    gray700: "#243B53",
    gray600: "#334E68",
    gray500: "#486581",
    gray400: "#5D7994",
    gray300: "#7E97AF",
    gray200: "#BCCCDC",
    gray100: "#D9E2EC",
    gray50: "#F0F4F8",
  },
  cyan: {
    cyan700: "#023236",
    cyan600: "#04484E",
    cyan500: "#0A6C74",
    cyan400: "#0B838E",
    cyan300: "#14919B",
    cyan200: "#29A3AE",
    cyan100: "#87EAF2",
    cyan50: "#BDF9FF",
  },
  red: {
    red700: "#610404",
    red600: "#780A0A",
    red500: "#911111",
    red400: "#A61B1B",
    red300: "#BA2525",
    red200: "#D64545",
    red100: "#F29B9B",
    red50: "#FFE0E0",
  },
  purple: {
    purple700: "#620042",
    purple600: "#870557",
    purple500: "#A30664",
    purple400: "#BC0A6F",
    purple300: "#DA127D",
    purple200: "#E8368F",
    purple100: "#FF8CBA",
    purple50: "#FFDBE7",
  },
  green: {
    green700: "#013C33",
    green600: "#064B3E",
    green500: "#0F6B55",
    green400: "#138163",
    green300: "#1C926E",
    green200: "#299E77",
    green100: "#75EBBC",
    green50: "#D0F6E4",
  },
  yellow: {
    yellow700: "#7A3006",
    yellow600: "#8D2B0B",
    yellow500: "#B44D12",
    yellow400: "#CD8518",
    yellow300: "#DE911D",
    yellow200: "#F0B129",
    yellow100: "#F7C948",
    yellow50: "#FCE68D",
  },
  black: "#000000",
  white: "#FFFFFF",
};

export default colors;
